import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import keyFeatData from '../assets/data/keyFeatData';

const KeyFeat = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    <div 
      className='w-full min-h-screen bg-[#F8FFE7] px-6 py-16 md:px-16 lg:px-24 xl:px-32 font-sans flex flex-col justify-start items-center'
      data-aos="fade-up" 
      data-aos-offset="50"
    >
      {/* Maximum Layout Bounding Outer Box */}
      <div className='w-full max-w-[1200px] flex flex-col gap-10 md:gap-14'>
        
        {/* Dynamic Section Header Title */}
        <div className='flex flex-col gap-2 text-center md:text-left'>
          <h2 className='text-[#6CA40B] text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight'>
            Cloud Computing Service<br />Key Features
          </h2>
        </div>

        {/* Multi-Device Matrix Grid Frame Configuration:
            1 Column on Mobile -> 2 Columns on Tablet -> 3 Columns on Laptops & Larger Displays
        */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch w-full'>
          {keyFeatData.map((item, index) => (
            <div 
              key={index} 
              className='bg-[#F8FFE7] border-4 border-black rounded-[28px] p-6 lg:p-8 flex flex-col gap-4 justify-start shadow-sm transition-all duration-300 min-h-[260px] md:min-h-[290px] lg:min-h-[320px]'
              data-aos={index % 2 === 0 ? "fade-up" : "fade-down"}
            >
              {/* Optional Vector Asset Graphic Icon Slot */}
              {item.img && (
                <img 
                  src={item.img} 
                  alt={item.title} 
                  className='h-10 w-10 object-contain self-start select-none pointer-events-none' 
                />
              )}

              {/* Title Copywriting Line */}
              <h3 className='font-bold text-[#022447] text-2xl lg:text-3xl tracking-tight leading-snug'>
                {item.title}
              </h3>

              {/* Body Content Description Layer */}
              <p className='text-[#1A202C] text-sm lg:text-base leading-relaxed font-normal'>
                {item.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default KeyFeat;